import api from 'api/direct-mail';
import handleResponse from './utils/handleResponse';
import { loadGzipJsonFromS3 } from 'utils/loadGzipJson';


export const getMailingPlan = async ({
  brandId,
  franchiseId,
  mailingPlanId,
  year
} = {}) => {
  try {
    // 1) Call your backend to get the presigned S3 URL
    const res = await handleResponse(
      api().post(`/brand/${brandId}/franchise/${franchiseId}/mailing-plan/get`, {
        mailingPlanId,
        mailingPlanTemplateYear: year
      })
    );

    // Guard: ensure handleResponse returned a tuple
    if (!Array.isArray(res) || res.length < 2) {
      const shapeErr = new Error('Unexpected handleResponse shape for getMailingPlan.');
      console.error(shapeErr, { res });
      return [shapeErr, null];
    }

    const [apiErr, payload] = res;

    // 2) Short-circuit if API errored
    if (apiErr) {
      // Keep logging minimal but helpful
      console.error('Mailing plan API error:', apiErr);
      return [apiErr, null];
    }

    console.log('Resolved Response payload:', payload);

    // 3) Extract the presigned URL defensively
     // Check for download URL
    const presignedUrl =  payload?.downloadUrl;
    if (presignedUrl) {
        console.log('Found presigned URL:', presignedUrl);
            // 4) Fetch + unzip + parse JSON from S3
            try {
            const parsedData = await loadGzipJsonFromS3(presignedUrl);
            console.log('Parsed Mailing Plan Data:', parsedData);
            return [null, parsedData];
            } catch (gzipErr) {
            // gzip/network/parse errors
            console.error('Failed to fetch/decompress S3 mailing plan JSON:', gzipErr);
            return [gzipErr, null];
            }
        }
         else{
            return [null,payload]
        }
        } catch (unexpectedErr) {
            // 5) Any truly unexpected runtime errors
            console.error('Unexpected error in getMailingPlan:', unexpectedErr);
            return [unexpectedErr, null];
        }
 
};


export const submitMailingPlan = ({
    brandId,
    franchiseId,
    mailingPlan
} = {}) => {
    return handleResponse(
        api().post(`/brand/${brandId}/franchise/${franchiseId}/mailing-plan/`, {
            ...mailingPlan   
        })
    );
}

export const saveDraftMailingPlan = ({
    brandId,
    franchiseId,
    mailingPlan
} = {}) => {
    return handleResponse(
        api().post(`/brand/${brandId}/franchise/${franchiseId}/mailing-plan/save`, {
            ...mailingPlan   
        })
    );
}

export const copyDraftMailingPlan = ({
    brandId,
    franchiseId,
    mailingPlan
} = {}) => {
    return handleResponse(
        api().post(`/brand/${brandId}/franchise/${franchiseId}/mailing-plan/copy`, {
            ...mailingPlan
        })
    );
}

export const overrideMailingPlan = ({
    mailingPlan
} = {}) => {
    return handleResponse(
        api().post('/corporate/mailing-plans/override', {
            ...mailingPlan   
        })
    );
}

export const approveMailingPlan = ({
    mailingPlanId
} = {}) => {
    return handleResponse(
        api().put(`/corporate/mailing-plan/approve`, {
            mailingPlanId
        })
    );
}

export const rejectMailingPlan = ({
    mailingPlanId,
    feedback
} = {}) => {
    return handleResponse(
        api().put(`/corporate/mailing-plan/reject`, {
            mailingPlanId,
            feedback
        })
    );
}

export const getSubmissions = ({
    brandId,
    franchiseId
} = {}) => {
    return handleResponse(
        api().post(`/brand/${brandId}/franchise/${franchiseId}/mailing-plan/recent`)
    );
}